
import API from "../utils/api";
import {
  ADD_FRAME_SCORE_START,
  ADD_FRAME_SCORE_SUCCESS,
  ADD_FRAME_SCORE_FAIL,
} from "../../constants/type";
import config from "../../constants/config";
import { toast } from "react-toastify";

export const addFrameScoresAction = (dataParams) => {
    return async function (dispatch) {
      dispatch({ type: ADD_FRAME_SCORE_START });
     await API.putRequest(`${config.BASE_URL}/match/updateFrameScores`, dataParams)
        .then(response => {
          dispatch({
            type: ADD_FRAME_SCORE_SUCCESS,
            payload: response
          });
          toast.success("The match score has been updated successfully.");
        })
        .catch(error => {
          toast.error(error?.response?.data?.message ?error.response.data.message:"Something went wrong");
          if (error.response) {          
            return dispatch({ type: ADD_FRAME_SCORE_FAIL, payload: error.response });
          } else {
            return dispatch({ type: ADD_FRAME_SCORE_FAIL, payload: error });
          }
  
        });
    };
  }